import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";
import Payment from "./Payment";
import Complain from "./Complain";
import BusBooking from "./BusBooking";
import ShipBooking from "./ShipBooking";
import Accounts from "./Accounts";
import CallCenterDashboard from "./CallCenterDashboard";
import AirlineBooking from "./AirlineBooking";

const CallCenterRoutes = [
    {
        path: "call-center",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Call Center",
        icon: ChatBubbleLeftRightIcon,
        children: [
            ...CallCenterDashboard,
            ...Complain,
            ...BusBooking,
            ...ShipBooking,
            ...AirlineBooking,
            ...Payment,
            ...Accounts,
        ],
    },
];

export default CallCenterRoutes;
